require('../base');

$(function(){

    // Specific for page home
    if($('body.home').length) {

    }

});